import {Component, HostListener, OnInit} from '@angular/core';
import { BasicFilters } from '../../model/filters/basic-filters';
import { SortOrder } from '../../model/sort-order';
import { JsonEditorService } from '../../services/json-editor.service';
import { TenantsService } from '../../services/tenants.service';
import { CommonMessagesService } from '../../services/common-messages.service';
import { AuthGuard } from '../../common/auth-guard.service';
import { Tenant } from '../../model/tenant';
import {FiltersService} from "../../services/filters.service";
import {ApplicationNotificationsServiceService} from "../../services/application-notifications.service";
import {ApplicationNotificationFilters} from "../../model/filters/application-notification.filters";
import {ApplicationNotification} from "../../model/application-notification";

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

  public notifications: ApplicationNotification[];
  public totalNotifications: number;
  public loadingNotifications: boolean;
  public tenants: Tenant[];

  public rows = 10;
  public first = 0;
  public selected = [];

  public notificationTypes: any[];

  public filtersVisible: boolean;
  public currentFilters: ApplicationNotificationFilters;

  public JsonEditorUtils = JsonEditorService;
  public filtersFilled: boolean;

  constructor(private notificationService: ApplicationNotificationsServiceService,
              private tenantsService: TenantsService,
              public authGuardService: AuthGuard,
              private commonMessagesService: CommonMessagesService,
              private filtersService: FiltersService<ApplicationNotificationFilters>) {
    this.currentFilters = new ApplicationNotificationFilters();
    this.notificationTypes = [
      {name: 'forms.notificationType.ALL', delay: 0},
      {name: 'forms.notificationType.HOURLY', delay: 3600},
      {name: 'forms.notificationType.DAILY', delay: 86400}
    ];
  }

  ngOnInit(): void {
    if (this.filtersService.getCurrentFilters(this.constructor.name) !== undefined) {
      this.filtersFilled = true;
    }
    this.notifications = new Array(this.rows);
    if (this.authGuardService.superAdminRequired()) {
      this.tenantsService.getTenants().subscribe(response => {
        this.tenants = response.tenants
          .sort((a, b) => a.name > b.name ? 1 : -1);
        Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
      });
    } else {
      Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
    }
  }

  private loadNotifications(offset?: number, limit?: number): void {
    this.loadingNotifications = true;
    this.notifications = new Array(this.rows);
    this.trimFieldsForm(this.currentFilters);
    this.notificationService.getNotifications(offset, limit, this.filtersService.getCurrentFilters(this.constructor.name) === undefined ? this.currentFilters: this.filtersService.getCurrentFilters(this.constructor.name))
      .subscribe(response => {
        this.notifications = response.applicationNotifications;
        let dataKey = 0;
        this.notifications.forEach(notification => {
          notification['dataKey'] = dataKey++;
        });
        this.totalNotifications = response.totalElements;
        this.loadingNotifications = false;
      });
  }

  onPageChange(event): void {
    this.currentFilters.sortField = event.sortField;
    this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.loadNotifications(event.first / event.rows, event.rows);
  }

  resetFilters(): void {
    this.currentFilters = new ApplicationNotificationFilters();
    this.currentFilters.sortField = 'name';
    this.currentFilters.sortOrder = SortOrder.ASCENDING;
    this.filtersFilled = false;
    this.filtersService.setCurrentFilters(undefined, this.constructor.name);
    this.applyFilters(true);
  }

  applyFilters(reset?: boolean): void {
    this.first = 0;
    if (reset !== true){
      this.filtersService.setCurrentFilters(this.currentFilters, this.constructor.name);
      this.filtersFilled = true;
    }
    this.loadNotifications(this.first / this.rows, this.rows);
  }

  confirmAndDelete(applicationNotification: ApplicationNotification): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => {
      this.deleteApplicationNotification(applicationNotification.tenantUuid, applicationNotification.uuid);
    });
  }

  deleteApplicationNotification(tenantUuid: string, uuid: string): void {

    this.tenantsService.deleteTenantApplicationNotification(tenantUuid, uuid).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadNotifications(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status);
    });
  }

  confirmAndDeleteSelected(): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => this.deleteSelected(), true);
  }

  deleteSelected(): void {
    if (this.selected.length === 0) { return; }
    const identifiers = this.selected.map(item => ({tenantUuid: item.tenantUuid, uuid: item.uuid}));

    this.notificationService.deleteApplicationNotifications(identifiers).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadNotifications(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status, true);
    });
  }

  trimFieldsForm(filters: BasicFilters): void {
    Object.keys(filters).forEach((key) => {
      if (filters[key] !== undefined && typeof filters[key] === 'string') {
        filters[key] = filters[key].trim();
      }
    });
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.key === 'f') {
      this.filtersVisible = true;
    }
    if (event.key === 'Escape') {
      this.filtersVisible = false;
    }
  }

  protected readonly isNaN = isNaN;
}
